import React from 'react';
import { motion } from 'framer-motion';
import { CHECKOUT_URL, PRICE_LABEL } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  label?: string;
  subLabel?: string;
  className?: string;
  href?: string;
};
export function CtaButton({
  label = `🧶 ¡SÍ, QUIERO APRENDER EL MÉTODO MAESTRO POR ${PRICE_LABEL}!`,
  subLabel,
  className = '',
  href = CHECKOUT_URL
}: CtaButtonProps) {
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Método Maestro Amigurumi',
      value: 19990,
      currency: 'ARS'
    });
  };
  return <div className={`w-full ${className}`} data-id="element-21" data-mp="109busqidlb58">
      <motion.a href={href} onClick={handleClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 22
    }} className="block w-full rounded-full bg-terracotta px-5 py-4 text-center text-[15px] font-extrabold uppercase tracking-wide text-cream shadow-soft ring-4 ring-terracotta-light/60 transition-colors hover:bg-terracotta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-ink sm:px-6 sm:py-5 sm:text-lg" data-id="element-22" data-mp="10c7twi5ym5v9">
        {label}
      </motion.a>
      {subLabel ? <p className="mt-3 text-center text-sm text-muted" data-id="element-23" data-mp="3ew9g4jyq97hi">{subLabel}</p> : null}
    </div>;
}